import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import Vant from 'vant'
import 'vant/lib/index.css'
import { Lazyload, Calendar, DatetimePicker } from 'vant'

import './assets/styles/main.css'

const app = createApp(App)

app.use(Vant)
app.use(Calendar)
app.use(DatetimePicker)
app.use(Lazyload)
app.use(store).use(router).mount('#app')
